import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
import { Observable, Subject, throwError } from 'rxjs';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { catchError, map, takeUntil} from 'rxjs/operators';
import { Resources } from '../../models/resources';
import { plainToClass, plainToInstance } from 'class-transformer';
import { ResourceStore } from 'src/app/stores/resources.store';

@Injectable()
export class ResourcesProvider {

  resources: Resources = Resources.defaults()

  ngUnsubscribeResources = new Subject();

  constructor(private _http: HttpClient,
    private resourceStore: ResourceStore) {

      this.resourceStore.state$.pipe(
        takeUntil(this.ngUnsubscribeResources),
        map((resources: Resources) => {
          this.copyResourcesFrom(resources);
        })
      ).subscribe(() => {
  
      });

      this.getResources().subscribe(() => {
        
      })
  }

  getResources(): Observable<Resources> {
    const observable = new Observable<Resources>( observer => {

      const value = this.loadResources();
      if (value && value.collections?.length > 0) {
        this.copyResourcesFrom(value)
        observer.next(this.resources)
        return
      }

      const token = localStorage.getItem('token');
      if (token != null && token.length > 0) {
        this._http.get('/resources?lastSync=' + this.resources.lastSync, {observe: 'response'})
                  .pipe(catchError(this.handleError))
                  .subscribe(r => {
                    if (r.body['status'] === 204) {
                      // Success but the api returned an empty body since its lastSync matches the lastSync we sent. DON'T
                      // call observer.next(this.resources) since that causes the page to needlessly update.
                      return
                    }

                    this.copyResourcesFrom(r.body['data'])
                    this.storeResources()
                    // (this.resources)

                    observer.next(this.resources)
                  });
      } else {
        observer.next(this.resources)
      }
    })
    return observable;
  }

  ngOnDestroy(){
    this.ngUnsubscribeResources.next(true);
    this.ngUnsubscribeResources.complete();
  }

  public setResourcesFromLogin(data: Object) {
    this.copyResourcesFrom(data)
    this.storeResources()
  }

  loadResources(): Resources {
    return this.resourceStore.getResources();
  }

  storeResources(): Promise<any> {
    return this.resourceStore.setResources(this.resources);
  }

  private copyResourcesFrom(data: Object) {
    const resources: Resources = plainToClass(Resources, data || Resources.defaults()) as Resources  // forced cast because type inference is wrong

    this.resources.teachingTools = resources.teachingTools
    this.resources.parentEducationMoments = resources.parentEducationMoments
    this.resources.videos = resources.videos
    this.resources.trainings = resources.trainings
    this.resources.collections = resources.collections
    this.resources.classTypes = resources.classTypes
    this.resources.callouts = resources.callouts
    this.resources.lastSync = resources.lastSync || 0
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
        // A client-side or network error occurred. Handle it accordingly.
        console.error('An error occurred:', error.error.message);
    } else {
        // The backend returned an unsuccessful response code.
        // The response body may contain clues as to what went wrong,
        console.error(
            `Backend returned code ${error.status}, ` +
            `body was: ${error.error}`);
    }
    // return an observable with a user-facing error message
    return throwError('Something bad happened retrieving resources; please try again later.');
  }

}
